import Vue from 'vue'
import {
  Icon,
  Button,
  Image,
  ImagePreview,
  CellGroup,
  Cell,
  Checkbox,
  List,
  Tabs,
  Tab,
  Swipe,
  SwipeItem,
  NoticeBar,
  Empty,
  Toast,
  Loading,
  Row,
  Col,
  Form,
  Field,
  RadioGroup,
  Radio,
  DatetimePicker,
  Popup,
  Calendar,
  Cascader,
  Stepper,
  Divider,
  Uploader,
  Dialog,
  Notify,
  Picker,
  Collapse,
  CollapseItem,
  Sticky,
  NavBar
} from 'vant'

// 将所有 Toast 的展示时长设置为 1500 毫秒
Toast.setDefaultOptions({ duration: 1500 })

// 将所有 loading Toast 设置为背景不可点击
Toast.setDefaultOptions('loading', { forbidClick: true, duration: 0 })

// 设置 Toast Fail icon
Toast.setDefaultOptions('fail', { icon: 'close' })



Vue.use(Icon)
Vue.use(Button)
Vue.use(Image)
Vue.use(ImagePreview)
Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Checkbox)
Vue.use(List)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(NoticeBar)
Vue.use(Empty)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(Field)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Calendar)
Vue.use(Cascader)
Vue.use(Stepper)
Vue.use(Divider)
Vue.use(Uploader)
Vue.use(Dialog)
Vue.use(Notify)
Vue.use(Picker)
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Sticky);
Vue.use(NavBar);

Vue.prototype.$ImagePreview = ImagePreview
